import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Menu,
  MenuItem,
  IconButton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import useAuth from "../hooks/useAuth";
import { useLocation } from "react-router-dom";

const Topbar = ({ onMenuClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { user, logout } = useAuth();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  // Get page title based on current route
  const getPageTitle = () => {
    const pathMap = {
      '/dashboard': 'Dashboard',
      '/customers': 'Customers',
      '/messaging-api-configs': 'Messaging API Config',
      '/salesforce-configs': 'Salesforce Config',
      '/manage-users': 'Manage Users',
      '/request-logs': 'Request Logs',
    };
    return pathMap[location.pathname] || 'Dashboard';
  };

  // Open menu
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close menu
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { xs: '100%', md: `calc(100% - 240px)` },
        marginLeft: { xs: 0, md: "240px" },
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        boxShadow: 0,
        borderBottom: `1px solid ${theme.palette.divider}`,
        zIndex: 1201,
      }}
    >
      <Toolbar sx={{ padding: { xs: 1, sm: 2 } }}>
        {/* Mobile Menu Button */}
        {isMobile && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={onMenuClick}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        )}

        {/* Page Title */}
        <Typography 
          variant={isMobile ? "h6" : "h5"} 
          sx={{ 
            flexGrow: 1,
            fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' }
          }}
        >
          {getPageTitle()}
        </Typography>

        {/* User Info Section */}
        {user && (
          <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 0.5, sm: 1 } }}>
            <Typography 
              variant="body2" 
              sx={{ 
                display: { xs: 'none', sm: 'block' },
                fontSize: { xs: '0.875rem', sm: '1rem' }
              }}
            >
              {user.name}
            </Typography>
            <IconButton onClick={handleMenuOpen} size="small">
              <Avatar
                alt={user.name}
                src={user.avatar || "https://via.placeholder.com/40"}
                sx={{ 
                  width: { xs: 32, sm: 40 }, 
                  height: { xs: 32, sm: 40 } 
                }}
              />
            </IconButton>
          </Box>
        )}

        {/* Dropdown Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem onClick={logout}>
            <LogoutIcon sx={{ mr: 1 }} />
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
